import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  AfterViewInit,
  ViewChild,
  Input
} from '@angular/core';

@Component({
  styleUrls: ['./jimButton.component.scss'],
  templateUrl: './jimButton.component.html'
})
export class PageJimButtonComponent {
}



// WEBPACK FOOTER //
// ./src/app/pages/jimButton/jimButton.component.ts